<script type="text/babel">
export default{
    data () {
        return {
            filterType: this.type,
            target: this.near,
        }
    },
    mounted () {
    },
    watch: {
        filterType(newVal, oldVal) {
            window.location = window.location.pathname + '?near=' + this.target + '&type=' + newVal;
        }
    },
    props: {
        type: {
            required: true,
            type: String
        },
        near: {
            required: false,
            default: null,
        }
    },
    computed: {},
    methods: {
        submitDealerFinder() {
            let urlParams = '?type=' + this.filterType;
            if (this.target) {
                urlParams += '&near=' + this.target;
            }
            window.location = window.location.pathname + urlParams;
        }

    }
}
</script>
